<template>
	<button @click="actionGoTo" :class="['sk-navigation-tab-item', { 'sk-navigation-tab-item--active': isActive }]"><span>{{ title }}</span></button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'navigation-tab-item',
	props: {
		route: {
			type: String,
			default: null
		},
		routeStartsWith: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: null
		}
	},
	methods: {
		actionGoTo() {
			if (!this.route)
				return

			this.$router.push({
				name: this.route,
				params: {
					user_uid: this.currentUser.uid
				}
			})
		}
	},
	computed: {
		isActive() {
			if (this.routeStartsWith) {
				return this.$route.name.startsWith(this.routeStartsWith)
			}
			return this.route === this.$route.name
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style scoped>
.sk-navigation-tab-item {
	padding: 0;
	border: 0;
	background: transparent;
	color: var(--main-font-color);
	font-size: 12px;
	box-sizing: border-box;
	cursor: pointer;
	text-decoration: none;
	outline: none;
	position: relative;
	transition: color 0.3s;
	width: 150px;
	display: flex;
	justify-content: center;
}
.sk-navigation-tab-item > span {
	padding: 7px 0;
	display: block;
	white-space: nowrap;
}
.sk-navigation-tab-item::after {
	content: ' ';
	display: block;
	height: 3px;
	width: 100%;
	background-color: var(--main-color);
	position: absolute;
	bottom: -2px;
	opacity: 0;
	transition: opacity 0.3s;
}
.sk-navigation-tab-item.sk-navigation-tab-item--active {
	color: #333;
	text-shadow: 0 0 .65px #333, 0 0 .65px #333;
}
.sk-navigation-tab-item.sk-navigation-tab-item--active::after {
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationTabItem.vue